module.exports = __webpack_public_path__ + "static/ayfc-crest-71dc3d646e0ac613844d3972d3f1dbda.png";